module.exports = __webpack_public_path__ + "img/P7.b487c0a7.png";